import { useMemo } from 'react';
import { getIn, useFormikContext }  from 'formik';
import { Input } from 'components/partials/Fields/FormikInput';

const Zipcode = ({
    name = 'zipcode',
    label: labelPrepend = '',
    labelAppend = '',
    countryField = 'country_id',
    ...props
}) => {
    const { values } = useFormikContext();
    const country_id = getIn(values, countryField);

    const countryMap = {
        '37': {
            label: 'Postal Code',
            mask: '*** ***',
        },
        '237': {
            label: 'Zipcode',
            mask: '99999',
        },
    };

    const label = useMemo(() => {
        const prepend = labelPrepend ? labelPrepend + ' ' : '';
        const text = countryMap[country_id]?.label ?? 'Zipcode';

        return prepend + text + labelAppend;
    }, [country_id, labelAppend]);

    return (
        <Input formik name={name} label={label} mask={countryMap[country_id]?.mask} {...props} />
    );
};

export default Zipcode;